import { render, staticRenderFns } from "./albumInfo.vue?vue&type=template&id=416a56f3&scoped=true"
import script from "./albumInfo.vue?vue&type=script&lang=js"
export * from "./albumInfo.vue?vue&type=script&lang=js"
import style0 from "./albumInfo.vue?vue&type=style&index=0&id=416a56f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a56f3",
  null
  
)

export default component.exports